// extracted by mini-css-extract-plugin
export default {"loading":"ProfileLoading_loading__Cy5Wd"};